// import { DialogErrorComponent } from './dialog-error/dialog-error.component';
// import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
// import { ApiDate } from '../models/api_models/apiDate';
// import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
// import { Station, StationAvailabilities, StationDetailGuest } from '../models/api_models/station';
// import { StationService } from '../api/station.service';
// import { BookService } from '../api/book.service';
// import { UserApiService } from '../user-api.service';
// import { LeafletMapComponent } from '../leaflet-map/leaflet-map.component';
// import { MatHorizontalStepper, MatStepper } from '@angular/material/stepper';
// import { ThemeServiceService } from '../theme-service.service';
// import { DomSanitizer } from '@angular/platform-browser';
// import { CookieService } from 'ngx-cookie-service';
// import { Router, NavigationEnd } from '@angular/router';
// import { parse } from 'path';
// import { ActivatedRoute } from '@angular/router';
// import { filter } from 'rxjs/operators';
// import { BehaviorSubject, Observable } from 'rxjs';
// import { trigger, state, style, animate, transition } from '@angular/animations';
// import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';



// @Component({
//   selector: 'app-search-book-form',
//   templateUrl: './search-book-form.component.html',
//   styleUrls: ['./search-book-form.component.scss'],
//   providers: [{
//     provide: STEPPER_GLOBAL_OPTIONS,
//     useValue: {
//       displayDefaultIndicatorType: false
//     }
//   }],
//   animations: [
//     // Each unique animation requires its own trigger. The first argument of the trigger function is the name
//     trigger('rotatedState', [
//       state('default', style({ transform: 'rotate(0)' })),
//       state('rotated', style({ transform: 'rotate(-360deg)' })),
//       transition('rotated => default', animate('400ms ease-out')),
//       transition('default => rotated', animate('400ms ease-in'))
//     ])
//   ]




// })
// export class SearchBookFormComponent implements OnInit {







//   private stationSbscribeSubject: BehaviorSubject<any>;
//   public station_sbscribe: Observable<any>;



//   //get token
//   public get station_sbscribeValue(): any {
//     return this.stationSbscribeSubject.value;
//   }











//   state: string = 'default';


//   rotate() {
//     this.state = (this.state === 'default' ? 'rotated' : 'default');
//   }


//   @ViewChild('leafletMap') leafletMapChild: LeafletMapComponent;
//   @ViewChild('stepper') stepper: MatStepper;
//   @Input() title: string = "Réserver";
//   @Input() type: string = "autopartage";

//   stationDetail: Station = undefined;
//   stationPriceText: StationDetailGuest = undefined;


//   private _stationAvailabilities: StationAvailabilities[];
//   get stationAvailabilities() {
//     return this._stationAvailabilities;
//   }
//   set stationAvailabilities(stationAvailabilities) {
//     this._stationAvailabilities = stationAvailabilities;
//   }


//   private _currentGps: [number, number] = [46.6651181, 2.0463107];
//   get currentGps() { return this._currentGps; }
//   @Input()
//   set currentGps(currentGps) {
//     this._currentGps = currentGps;

//   }

//   private _zoom: number = 14;
//   get zoom(): number {
//     return this._zoom;
//   }
//   @Input()
//   set zoom(zoom: number) {
//     this._zoom = zoom;
//   }

//   img = "";
//   getImg() {
//     this.img = "data:" + this.stationDetail.detail.image.mimetype + ";base64, " + this.stationDetail.detail.image.file;
//   }



//   private _stations: Station[];
//   get stations(): Station[] {
//     return this._stations;
//   }
//   @Input()
//   set stations(stations) {
//     this._stations = stations;
//   }

//   isStationDetail: boolean = false;

//   private _mapStationSelected: Station;
//   get mapStationSelected(): Station {
//     return this._mapStationSelected;
//   }
//   @Input()
//   set mapStationSelected(mapStationSelected) {
//     this.getStationDetail(mapStationSelected)
//     this._mapStationSelected = mapStationSelected;
//   }

//   getStationDetail(station: Station) {
//     this.stationService.getStationDetail(station).subscribe(
//       response => {
//         // conslog(response);
//       }
//     );
//   }


//   departure_date: ApiDate;
//   arrival_date: ApiDate;
//   param_departure = ["Date de départ", "Heure de départ"];
//   param_arrival = ["Date d'arrivée", "Heure d'arrivée"];
//   isLog = false;

//   _stationConfirm: StationAvailabilities = null;

//   currentStep = 0;




//   // open dialog
//   openDialog(message) {
//     this.dialog.open(DialogErrorComponent, {
//       data: message
//     });
//   }


//   //verification date null or startdate > enddate
//   public check_search() {
//     if (this._mapStationSelected == null && this.adressGps == null) {
//       return false;
//     }
//     let tmpStartDate = new Date(this.departure_date.getDateToApiFormat());
//     let tmpArrivalDate = new Date(this.arrival_date.getDateToApiFormat());
//     let getStart = tmpStartDate.getTime() + 1800000;
//     let getDateNow = new Date().getTime();
//     let message1 = 'Heure déjà passée, sélectionnez une nouvelle heure'
//     let message2 = 'La date est invalide'

//     if (getStart < getDateNow) {
//       this.openDialog(message1)
//       return false;
//     }

//     if (tmpStartDate >= tmpArrivalDate) {
//       this.openDialog(message2)
//       return false;

//     }
//     return true;
//   }



//   constructor(public dialog: MatDialog, private route: ActivatedRoute, private cookieService: CookieService, private router: Router, private stationService: StationService, private bookService: BookService, private userService: UserApiService, private themeService: ThemeServiceService, public _DomSanitizationService: DomSanitizer)
//    {

//     this.getSite()
//     // date depart 
//     this.departure_date = new ApiDate;
//     this.departure_date.date = new Date();
//     this.departure_date.hour = this.departure_date.date.getHours().toString();
//     let intMin = this.departure_date.date.getMinutes();
//     let intHour = this.departure_date.date.getHours();
    
//     // this.testghiles(intMin);
//     (intMin >= 30) ? this.departure_date.min = "30" : this.departure_date.min = "0";
//     this.departure_date.updateDate();

//     // date arrivé
//     this.arrival_date = new ApiDate;
//     this.arrival_date.date = new Date();
//     this.arrival_date.date.setTime(this.arrival_date.date.getTime() + 30 * 60 * 1000);
//     this.arrival_date.hour = this.arrival_date.date.getHours().toString();
//     intMin = this.arrival_date.date.getMinutes();
//     (intMin >= 30) ? this.arrival_date.min = "30" : this.arrival_date.min = "0";
//     this.arrival_date.updateDate();




//     router.events.pipe(
//       filter(event => event instanceof NavigationEnd)
//     ).subscribe((event: NavigationEnd) => {
//       // console.log(event.url);
//       this.seletedService = event.url
//     });


//     this.stationSbscribeSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('station_sbscribe')));
//     this.station_sbscribe = this.stationSbscribeSubject.asObservable();



//     this.route
//       .queryParamMap
//       .subscribe(query => {
//         // Defaults to 0 if no query param provided.

//         console.log('--------ghiles------------')
//         console.log(query.get('station'))
//         let station: any = { id: parseInt(query.get('station')) || 0 }

//         console.log('--------ghiles------------')

//         console.log(station)

//         if (station.id !== 0) {

//           this.stationService.getStationPriceTextGuest(station.id).subscribe(response => {
//             this.stationPriceText = response;
//           },
//             error => {
//               console.log(error)
//             })
//           this.stationService.getStationDetail(station).subscribe(
//             response => {
//               this.stationDetail = response;
//               this.rotate()
//               this.getImg();
//               this._currentGps = [this.stationDetail.latitude, this.stationDetail.longitude];
//               this._zoom = 12;
//               this.mapStationSelected = response //ghiles
//             },
//             error => {
//               console.log(error)
//             }
//           )


//         }




//       });

//   }




//   seletedService: string;

//   ngOnInit() {
//     this.gpsfun()

//   }


//   addressChangeHandler(gps: any) {
//     this._currentGps = gps;
//     this._zoom = 12;

//   }



//   testghiles(int){
//     console.log('################################################################------------------------')

//     console.log(int)
//     console.log('################################################################------------------------')
    
//   }


//   stationChangedHandler(stationFocus: Station) {



//     console.log("stationFocus ==========",stationFocus);

//     this.router.navigate([], { queryParams: { station: stationFocus.id } });




//     this.stationService.getStationPriceTextGuest(stationFocus.id).subscribe(response => {
//       this.stationPriceText = response;
//     },
//       error => {
//         console.log(error)
//       })
//     this.stationService.getStationDetail(stationFocus).subscribe(
//       response => {
//         this.stationDetail = response;
//         this.rotate()
//         this.getImg();
//       },
//       error => {
//         console.log(error)
//       }
//     )
//     this._currentGps = [stationFocus.latitude, stationFocus.longitude];
//     this._zoom = 12;
//     this._mapStationSelected = stationFocus;
//   }



//   get arrivalDateStr() {
//     return this.arrival_date.getDateToApiFormat();
//   }
//   get departureDateStr() {
//     return this.arrival_date.getDateToApiFormat();
//   }

//   CheckForm(event) {
//   }



//   //search by gps
//   adressGps;

//   gpsfun() {
//     this.bookService.event.subscribe((data) => {

//       this.adressGps = data

//     });
//   }

//   // search stations 
//   searchBook() {

//     if (this.stationDetail?.detail?.type === 10 && this.stationDetail?.detail?.immediate_service === true) {
//       // this.departure_date = new ApiDate;
//       this.departure_date.date = new Date();
//       this.departure_date.hour = this.departure_date.date.getHours().toString();
//        console.log('ghiles----------------------ghiles')
//        console.log(this.departure_date )
//      }


//     if (this.check_search()) {

//       let dataStr = localStorage.getItem('token_clem_mobi');
//       if (dataStr == null || dataStr == "") {


//         if ((this._mapStationSelected?.detail.type === 0 || this._mapStationSelected?.detail.type === 7) && this._mapStationSelected?.detail.modeaccess === 1) {
//           this.router.navigate([`/recharge-sans-inscription/${this._mapStationSelected?.detail.guid}/${this._mapStationSelected.detail.id_pl}`])
//         } else {

//           console.log("this.stationDetail ",this.stationDetail?.id) 
//           this.router.navigate( ['/connexion'], { queryParams: { station: this.stationDetail?.id } } );

//           localStorage.setItem('station_sbscribe', JSON.stringify(this._mapStationSelected.detail.subscription_community));
//           this.stationSbscribeSubject.next(this._mapStationSelected.detail.subscription_community);

//           setTimeout(function () { console.log('your name'); localStorage.removeItem('station_sbscribe'); }, 20000);

//         }

//       }
//       else {

//         this.stepper.selected.completed = true;
//         this.stepper.next();

//         this._stationAvailabilities = [];


//         var tmpStartDate = new Date(this.departure_date.getDateToApiFormat());
//         tmpStartDate.setHours(0, 0, 0, 0);



//         var date_start = this.departure_date.date.getFullYear() + "-" +
//           ("0" + (this.departure_date.date.getMonth() + 1)).slice(-2) + "-" +
//           ("0" + this.departure_date.date.getDate()).slice(-2) + "T" +
//           ("0" + this.departure_date.date.getHours()).slice(-2) + ":" +
//           ("0" + this.departure_date.date.getMinutes()).slice(-2) + ":" +
//           ("0" + this.departure_date.date.getSeconds()).slice(-2) + "Z";

//         var date_end = this.arrival_date.date.getFullYear() + "-" +
//           ("0" + (this.arrival_date.date.getMonth() + 1)).slice(-2) + "-" +
//           ("0" + this.arrival_date.date.getDate()).slice(-2) + "T" +
//           ("0" + this.arrival_date.date.getHours()).slice(-2) + ":" +
//           ("0" + this.arrival_date.date.getMinutes()).slice(-2) + ":" +
//           ("0" + this.arrival_date.date.getSeconds()).slice(-2) + "Z";

//         console.log("departure_date")
//         console.log(date_start)
//         console.log('arrival_date')
//         console.log(date_end)


//         // this.departure_date.date = new Date();
//         // console.log('ghiles----------------------ghiles')
//         // console.log(this.departure_date )



//         if (this.mapStationSelected?.type === 11) {
//           var date_start = new Date().getFullYear() + "-" +
//             ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" +
//             ("0" + new Date().getDate()).slice(-2) + "T" +
//             ("0" + new Date().getHours()).slice(-2) + ":" +
//             ("0" + new Date().getMinutes()).slice(-2) + ":" +
//             ("0" + new Date().getSeconds()).slice(-2) + "Z";
//         }
//         if (this.mapStationSelected?.type === 7) {
//           var date_start = new Date().getFullYear() + "-" +
//             ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" +
//             ("0" + new Date().getDate()).slice(-2) + "T" +
//             ("0" + new Date().getHours()).slice(-2) + ":" +
//             ("0" + new Date().getMinutes()).slice(-2) + ":" +
//             ("0" + new Date().getSeconds()).slice(-2) + "Z";
//         }

      



//         let tmpArrivalDate = new Date(this.arrival_date.getDateToApiFormat());
//         tmpArrivalDate.setHours(23, 59, 0, 0);
//         tmpArrivalDate.setTime(tmpArrivalDate.getTime() + 24 * 60 * 60 * 1000);

//         if (this._mapStationSelected !== undefined) {

//           //  if(this._mapStationSelected.detail.type === 7){
//           //   var date_start = new Date().getFullYear() + "-" +
//           //   ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" +
//           //   ("0" + new Date().getDate()).slice(-2) + "T" +
//           //   ("0" + new Date().getHours()).slice(-2) + ":" +
//           //   ("0" + new Date().getMinutes() > '30' ? this.arrival_date.min = "30" : this.arrival_date.min = "00").slice(-2) + ":" +
//           //   ("0" + new Date().getSeconds()).slice(-2) + "Z";
//           //   var tmpStartDate = new Date();
//           //   tmpStartDate.setHours(0, 0, 0, 0);
//           //  }

//           //  if(this._mapStationSelected.detail.type === 10){
//           //   var date_start = new Date().getFullYear() + "-" +
//           //   ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" +
//           //   ("0" + new Date().getDate()).slice(-2) + "T" +
//           //   ("0" + new Date().getHours()).slice(-2) + ":" +
//           //   ("0" + new Date().getMinutes() > '30' ? this.arrival_date.min = "30" : this.arrival_date.min = "00").slice(-2) + ":" +
//           //   ("0" + new Date().getSeconds()).slice(-2) + "Z";
//           //   var tmpStartDate = new Date();
//           //   tmpStartDate.setHours(0, 0, 0, 0);
//           //  }

//           //  if (this.mapStationSelected?.type === 10) {
//           //   this.departure_date  = new ApiDate;
//           //   console.log('ghiles-----------non-----------ghiles')
//           //   console.log(this.departure_date )
//           // }

//           console.log('remli' + this._mapStationSelected )
//           console.log(this._mapStationSelected )
//           console.log(tmpStartDate.toISOString() )
//           console.log(tmpArrivalDate.toISOString())
//           console.log(date_start )
//           console.log(date_end )

//           this.isLog = true;
//           this.stationService.getStationAvailabilities(this._mapStationSelected, tmpStartDate.toISOString(), tmpArrivalDate.toISOString(), date_start, date_end).subscribe(
//             response => {
//               this._stationAvailabilities = this._stationAvailabilities.concat(response);
//               this.isStationDetail = true;



//               if (this._stationAvailabilities.length === 0) {
//                 console.log('iffffff')
//                 this.stationService.getStationAvailble(this._mapStationSelected, tmpStartDate.toISOString(), tmpArrivalDate.toISOString(), date_start, date_end)
//                   .subscribe(res => {

//                     this._stationAvailabilities = [{
//                       "availabilities": res.data, "distance": 0,
//                       "id": this._mapStationSelected.id, "latitude": this._mapStationSelected.latitude, "longitude": this._mapStationSelected.longitude,
//                       "name": this._mapStationSelected.name,
//                       "station_name": ""
//                     }]
//                   })


//               }



//             },
//             error => {
//             }
//           );


//         }

//         if (this.adressGps !== undefined) {

//           // this.isLog = true;
//           if (this.seletedService == undefined || this.seletedService === "/autopartage") {
//             var type = "type[]=1&type[]=10"

//           }
//           if (this.seletedService === "/recharge") {
//             var type = "type[]=0&type[]=7"

//           }
//           this.stationService.getStationAvailabilitiesWithGPS(type, this.adressGps.lng, this.adressGps.lat, tmpStartDate.toISOString(), tmpArrivalDate.toISOString(), date_start, date_end ).subscribe(
//             response => {
//               this._stationAvailabilities = response.data
//               // console.log(response)
//               this.isStationDetail = true;
//               this.rotate()
//             },
//             error => {
//               error
//             }
//           );


//           //----------------------

//         }

//       }

//     }

//   }





//   @ViewChild('wave') wave;

//   ngAfterViewInit() {

//   }

//   //confirme station
//   public confirmStation(stationId) {
//     this._stationAvailabilities.forEach(station => {
//       if (stationId == station.id) {
//         this.stepper.selected.completed = true;
//         this.stepper.selectedIndex = 2;
//         this._stationConfirm = station;
//       }
//     });

//   }




//   openNewTab(latitude,longitude) {
//     const url = `https://maps.google.com/maps?&z=7&q=${latitude}+${longitude}`
//     window.open(url, '_blank');
//   }




//  siteType = 'default';

// getSite() {
//   const host = location.host;

//   switch (host) {
    
//     case 'mam.clem.mobi':
//     case 'www.mam.clem.mobi':
//       this.siteType = 'mam';
//       break;

//     case 'remiautopartage.clem.mobi':
//     case 'www.remiautopartage.clem.mobi':
//     // case 'localhost:4200':
//     // case `devghiles.clem.mobi` : 
//       this.siteType = 'remi';
//       break;

//     default:
//       this.siteType = 'default';
//   }
// }



// }








import { DialogErrorComponent } from './dialog-error/dialog-error.component';
import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ApiDate } from '../models/api_models/apiDate';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { Station, StationAvailabilities, StationDetailGuest } from '../models/api_models/station';
import { StationService } from '../api/station.service';
import { BookService } from '../api/book.service';
import { UserApiService } from '../user-api.service';
import { LeafletMapComponent } from '../leaflet-map/leaflet-map.component';
import { MatHorizontalStepper, MatStepper } from '@angular/material/stepper';
import { ThemeServiceService } from '../theme-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { Router, NavigationEnd } from '@angular/router';
import { parse } from 'path';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';



@Component({
  selector: 'app-search-book-form',
  templateUrl: './search-book-form.component.html',
  styleUrls: ['./search-book-form.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS,
    useValue: {
      displayDefaultIndicatorType: false
    }
  }],
  animations: [
    // Each unique animation requires its own trigger. The first argument of the trigger function is the name
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-360deg)' })),
      transition('rotated => default', animate('400ms ease-out')),
      transition('default => rotated', animate('400ms ease-in'))
    ])
  ]




})
export class SearchBookFormComponent implements OnInit {







  private stationSbscribeSubject: BehaviorSubject<any>;
  public station_sbscribe: Observable<any>;



  //get token
  public get station_sbscribeValue(): any {
    return this.stationSbscribeSubject.value;
  }

  //lecture defensive du localStorage : evite le crash JSON.parse("undefined")
  private getStoredStationSbscribe(): any {
    const raw = localStorage.getItem('station_sbscribe');
    if (!raw || raw === 'undefined' || raw === 'null') {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch (e) {
      console.warn('station_sbscribe invalide en localStorage:', raw);
      return null;
    }
  }











  state: string = 'default';


  rotate() {
    this.state = (this.state === 'default' ? 'rotated' : 'default');
  }


  @ViewChild('leafletMap') leafletMapChild: LeafletMapComponent;
  @ViewChild('stepper') stepper: MatStepper;
  @Input() title: string = "Réserver";
  @Input() type: string = "autopartage";

  stationDetail: Station = undefined;
  stationPriceText: StationDetailGuest = undefined;


  private _stationAvailabilities: StationAvailabilities[];
  get stationAvailabilities() {
    return this._stationAvailabilities;
  }
  set stationAvailabilities(stationAvailabilities) {
    this._stationAvailabilities = stationAvailabilities;
  }


  private _currentGps: [number, number] = [46.6651181, 2.0463107];
  get currentGps() { return this._currentGps; }
  @Input()
  set currentGps(currentGps) {
    this._currentGps = currentGps;

  }

  private _zoom: number = 14;
  get zoom(): number {
    return this._zoom;
  }
  @Input()
  set zoom(zoom: number) {
    this._zoom = zoom;
  }

  img = "";
  getImg() {
    this.img = "data:" + this.stationDetail.detail.image.mimetype + ";base64, " + this.stationDetail.detail.image.file;
  }



  private _stations: Station[];
  get stations(): Station[] {
    return this._stations;
  }
  @Input()
  set stations(stations) {
    this._stations = stations;
  }

  isStationDetail: boolean = false;

  private _mapStationSelected: Station;
  get mapStationSelected(): Station {
    return this._mapStationSelected;
  }
  @Input()
  set mapStationSelected(mapStationSelected) {
    this.getStationDetail(mapStationSelected)
    this._mapStationSelected = mapStationSelected;
  }

  getStationDetail(station: Station) {
    this.stationService.getStationDetail(station).subscribe(
      response => {
        // conslog(response);
      }
    );
  }


  departure_date: ApiDate;
  arrival_date: ApiDate;
  param_departure = ["Date de départ", "Heure de départ"];
  param_arrival = ["Date d'arrivée", "Heure d'arrivée"];
  isLog = false;

  _stationConfirm: StationAvailabilities = null;

  currentStep = 0;




  // open dialog
  openDialog(message) {
    this.dialog.open(DialogErrorComponent, {
      data: message
    });
  }


  //verification date null or startdate > enddate
  public check_search() {
    if (this._mapStationSelected == null && this.adressGps == null) {
      return false;
    }
    let tmpStartDate = new Date(this.departure_date.getDateToApiFormat());
    let tmpArrivalDate = new Date(this.arrival_date.getDateToApiFormat());
    let getStart = tmpStartDate.getTime() + 1800000;
    let getDateNow = new Date().getTime();
    let message1 = 'Heure déjà passée, sélectionnez une nouvelle heure'
    let message2 = 'La date est invalide'

    if (getStart < getDateNow) {
      this.openDialog(message1)
      return false;
    }

    if (tmpStartDate >= tmpArrivalDate) {
      this.openDialog(message2)
      return false;

    }
    return true;
  }



  constructor(public dialog: MatDialog, private route: ActivatedRoute, private cookieService: CookieService, private router: Router, private stationService: StationService, private bookService: BookService, private userService: UserApiService, private themeService: ThemeServiceService, public _DomSanitizationService: DomSanitizer)
   {

    this.getSite()
    // date depart 
    this.departure_date = new ApiDate;
    this.departure_date.date = new Date();
    this.departure_date.hour = this.departure_date.date.getHours().toString();
    let intMin = this.departure_date.date.getMinutes();
    let intHour = this.departure_date.date.getHours();
    
    // this.testghiles(intMin);
    (intMin >= 30) ? this.departure_date.min = "30" : this.departure_date.min = "0";
    this.departure_date.updateDate();

    // date arrivé
    this.arrival_date = new ApiDate;
    this.arrival_date.date = new Date();
    this.arrival_date.date.setTime(this.arrival_date.date.getTime() + 30 * 60 * 1000);
    this.arrival_date.hour = this.arrival_date.date.getHours().toString();
    intMin = this.arrival_date.date.getMinutes();
    (intMin >= 30) ? this.arrival_date.min = "30" : this.arrival_date.min = "0";
    this.arrival_date.updateDate();




    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // console.log(event.url);
      this.seletedService = event.url
    });


    this.stationSbscribeSubject = new BehaviorSubject<any>(this.getStoredStationSbscribe());
    this.station_sbscribe = this.stationSbscribeSubject.asObservable();



    this.route
      .queryParamMap
      .subscribe(query => {
        // Defaults to 0 if no query param provided.

        console.log(query.get('station'))
        let station: any = { id: parseInt(query.get('station')) || 0 }

       

        console.log(station)

        if (station.id !== 0) {

          this.stationService.getStationPriceTextGuest(station.id).subscribe(response => {
            this.stationPriceText = response;
          },
            error => {
              console.log(error)
            })
          this.stationService.getStationDetail(station).subscribe(
            response => {
              this.stationDetail = response;
              this.rotate()
              this.getImg();
              this._currentGps = [this.stationDetail.latitude, this.stationDetail.longitude];
              this._zoom = 12;
              this.mapStationSelected = response //ghiles
            },
            error => {
              console.log(error)
            }
          )


        }




      });

  }




  seletedService: string;

  ngOnInit() {
    this.gpsfun()

  }


  addressChangeHandler(gps: any) {
    this._currentGps = gps;
    this._zoom = 12;

  }



  testghiles(int){
    console.log('################################################################------------------------')

    console.log(int)
    console.log('################################################################------------------------')
    
  }


  stationChangedHandler(stationFocus: Station) {



    console.log("stationFocus ==========",stationFocus);

    this.router.navigate([], { queryParams: { station: stationFocus.id } });




    this.stationService.getStationPriceTextGuest(stationFocus.id).subscribe(response => {
      this.stationPriceText = response;
    },
      error => {
        console.log(error)
      })
    this.stationService.getStationDetail(stationFocus).subscribe(
      response => {
        this.stationDetail = response;
        this.rotate()
        this.getImg();
      },
      error => {
        console.log(error)
      }
    )
    this._currentGps = [stationFocus.latitude, stationFocus.longitude];
    this._zoom = 12;
    this._mapStationSelected = stationFocus;
  }



  get arrivalDateStr() {
    return this.arrival_date.getDateToApiFormat();
  }
  get departureDateStr() {
    return this.arrival_date.getDateToApiFormat();
  }

  CheckForm(event) {
  }



  //search by gps
  adressGps;

  gpsfun() {
    this.bookService.event.subscribe((data) => {

      this.adressGps = data

    });
  }

  // search stations 
  searchBook() {

    if (this.stationDetail?.detail?.type === 10 && this.stationDetail?.detail?.immediate_service === true) {
      // this.departure_date = new ApiDate;
      this.departure_date.date = new Date();
      this.departure_date.hour = this.departure_date.date.getHours().toString();
       console.log('ghiles----------------------ghiles')
       console.log(this.departure_date )
     }


    if (this.check_search()) {

      let dataStr = localStorage.getItem('token_clem_mobi');
      if (dataStr == null || dataStr == "") {


        if ((this._mapStationSelected?.detail.type === 0 || this._mapStationSelected?.detail.type === 7) && this._mapStationSelected?.detail.modeaccess === 1) {
          this.router.navigate([`/recharge-sans-inscription/${this._mapStationSelected?.detail.guid}/${this._mapStationSelected.detail.id_pl}`])
        } else {

          console.log("this.stationDetail ",this.stationDetail?.id) 
          this.router.navigate( ['/connexion'], { queryParams: { station: this.stationDetail?.id } } );

          const subscriptionCommunity = this._mapStationSelected?.detail?.subscription_community;
          if (subscriptionCommunity !== undefined) {
            localStorage.setItem('station_sbscribe', JSON.stringify(subscriptionCommunity));
            this.stationSbscribeSubject.next(subscriptionCommunity);
          } else {
            localStorage.removeItem('station_sbscribe');
            this.stationSbscribeSubject.next(null);
          }

          setTimeout(function () { console.log('your name'); localStorage.removeItem('station_sbscribe'); }, 20000);

        }

      }
      else {

        this._stationConfirm = null; // ← ajout : évite tout état résiduel d'une recherche précédente

        // Bloque l'accès à l'étape "Confirmation" par clic sur l'en-tête
        // tant qu'un nouveau créneau n'a pas été validé via confirmStation()
        const steps = this.stepper.steps.toArray();
        if (steps[2]) {
          steps[2].completed = false;
        }


        this.stepper.selected.completed = true;
        this.stepper.next();

        this._stationAvailabilities = [];


        var tmpStartDate = new Date(this.departure_date.getDateToApiFormat());
        tmpStartDate.setHours(0, 0, 0, 0);



        var date_start = this.departure_date.date.getFullYear() + "-" +
          ("0" + (this.departure_date.date.getMonth() + 1)).slice(-2) + "-" +
          ("0" + this.departure_date.date.getDate()).slice(-2) + "T" +
          ("0" + this.departure_date.date.getHours()).slice(-2) + ":" +
          ("0" + this.departure_date.date.getMinutes()).slice(-2) + ":" +
          ("0" + this.departure_date.date.getSeconds()).slice(-2) + "Z";

        var date_end = this.arrival_date.date.getFullYear() + "-" +
          ("0" + (this.arrival_date.date.getMonth() + 1)).slice(-2) + "-" +
          ("0" + this.arrival_date.date.getDate()).slice(-2) + "T" +
          ("0" + this.arrival_date.date.getHours()).slice(-2) + ":" +
          ("0" + this.arrival_date.date.getMinutes()).slice(-2) + ":" +
          ("0" + this.arrival_date.date.getSeconds()).slice(-2) + "Z";

        console.log("departure_date")
        console.log(date_start)
        console.log('arrival_date')
        console.log(date_end)


        // this.departure_date.date = new Date();
        // console.log('ghiles----------------------ghiles')
        // console.log(this.departure_date )



        if (this.mapStationSelected?.type === 11) {
          var date_start = new Date().getFullYear() + "-" +
            ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" +
            ("0" + new Date().getDate()).slice(-2) + "T" +
            ("0" + new Date().getHours()).slice(-2) + ":" +
            ("0" + new Date().getMinutes()).slice(-2) + ":" +
            ("0" + new Date().getSeconds()).slice(-2) + "Z";
        }
        if (this.mapStationSelected?.type === 7) {
          var date_start = new Date().getFullYear() + "-" +
            ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" +
            ("0" + new Date().getDate()).slice(-2) + "T" +
            ("0" + new Date().getHours()).slice(-2) + ":" +
            ("0" + new Date().getMinutes()).slice(-2) + ":" +
            ("0" + new Date().getSeconds()).slice(-2) + "Z";
        }

      



        let tmpArrivalDate = new Date(this.arrival_date.getDateToApiFormat());
        tmpArrivalDate.setHours(23, 59, 0, 0);
        tmpArrivalDate.setTime(tmpArrivalDate.getTime() + 24 * 60 * 60 * 1000);

        if (this._mapStationSelected !== undefined) {

          //  if(this._mapStationSelected.detail.type === 7){
          //   var date_start = new Date().getFullYear() + "-" +
          //   ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" +
          //   ("0" + new Date().getDate()).slice(-2) + "T" +
          //   ("0" + new Date().getHours()).slice(-2) + ":" +
          //   ("0" + new Date().getMinutes() > '30' ? this.arrival_date.min = "30" : this.arrival_date.min = "00").slice(-2) + ":" +
          //   ("0" + new Date().getSeconds()).slice(-2) + "Z";
          //   var tmpStartDate = new Date();
          //   tmpStartDate.setHours(0, 0, 0, 0);
          //  }

          //  if(this._mapStationSelected.detail.type === 10){
          //   var date_start = new Date().getFullYear() + "-" +
          //   ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" +
          //   ("0" + new Date().getDate()).slice(-2) + "T" +
          //   ("0" + new Date().getHours()).slice(-2) + ":" +
          //   ("0" + new Date().getMinutes() > '30' ? this.arrival_date.min = "30" : this.arrival_date.min = "00").slice(-2) + ":" +
          //   ("0" + new Date().getSeconds()).slice(-2) + "Z";
          //   var tmpStartDate = new Date();
          //   tmpStartDate.setHours(0, 0, 0, 0);
          //  }

          //  if (this.mapStationSelected?.type === 10) {
          //   this.departure_date  = new ApiDate;
          //   console.log('ghiles-----------non-----------ghiles')
          //   console.log(this.departure_date )
          // }

          console.log('remli' + this._mapStationSelected )
          console.log(this._mapStationSelected )
          console.log(tmpStartDate.toISOString() )
          console.log(tmpArrivalDate.toISOString())
          console.log(date_start )
          console.log(date_end )

          this.isLog = true;
          this.stationService.getStationAvailabilities(this._mapStationSelected, tmpStartDate.toISOString(), tmpArrivalDate.toISOString(), date_start, date_end).subscribe(
            response => {
              this._stationAvailabilities = this._stationAvailabilities.concat(response);
              this.isStationDetail = true;



              if (this._stationAvailabilities.length === 0) {
                console.log('iffffff')
                this.stationService.getStationAvailble(this._mapStationSelected, tmpStartDate.toISOString(), tmpArrivalDate.toISOString(), date_start, date_end)
                  .subscribe(res => {

                    this._stationAvailabilities = [{
                      "availabilities": res.data, "distance": 0,
                      "id": this._mapStationSelected.id, "latitude": this._mapStationSelected.latitude, "longitude": this._mapStationSelected.longitude,
                      "name": this._mapStationSelected.name,
                      "station_name": ""
                    }]
                  })


              }



            },
            error => {
            }
          );


        }

        if (this.adressGps !== undefined) {

          // this.isLog = true;
          if (this.seletedService == undefined || this.seletedService === "/autopartage") {
            var type = "type[]=1&type[]=10"

          }
          if (this.seletedService === "/recharge") {
            var type = "type[]=0&type[]=7"

          }
          this.stationService.getStationAvailabilitiesWithGPS(type, this.adressGps.lng, this.adressGps.lat, tmpStartDate.toISOString(), tmpArrivalDate.toISOString(), date_start, date_end ).subscribe(
            response => {
              this._stationAvailabilities = response.data
              // console.log(response)
              this.isStationDetail = true;
              this.rotate()
            },
            error => {
              error
            }
          );


          //----------------------

        }

      }

    }

  }





  @ViewChild('wave') wave;

  ngAfterViewInit() {

  }

  //confirme station
  public confirmStation(stationId) {
    this._stationAvailabilities.forEach(station => {
      if (stationId == station.id) {
        this.stepper.selected.completed = true;
        this.stepper.selectedIndex = 2;
        this._stationConfirm = station;
      }
    });

  }




  openNewTab(latitude,longitude) {
    const url = `https://maps.google.com/maps?&z=7&q=${latitude}+${longitude}`
    window.open(url, '_blank');
  }




 siteType = 'default';

getSite() {
  const host = location.host;

  switch (host) {
    
    case 'mam.clem.mobi':
    case 'www.mam.clem.mobi':
      this.siteType = 'mam';
      break;

    case 'remiautopartage.clem.mobi':
    case 'www.remiautopartage.clem.mobi':
    // case 'localhost:4200':
    // case `devghiles.clem.mobi` : 
      this.siteType = 'remi';
      break;

    default:
      this.siteType = 'default';
  }
}



}
